module.exports = __webpack_public_path__ + "img/Mascherina_DX.fcd6ec0e.png";